export const MAX_TOPIC_NAME_LENGTH = 200

const isAsciiTopicWhitespace = (char: string): boolean =>
  char === ' ' ||
  char === '\t' ||
  char === '\n' ||
  char === '\r' ||
  char === '\f' ||
  char === '\v'

/** Remove exactly the ASCII whitespace bytes in the topic-name contract.
 * JavaScript's `trim()` is intentionally not used because it also removes
 * Unicode whitespace that the server and database must preserve. */
export function normalizeTopicName(value: string): string {
  let start = 0
  let end = value.length
  while (start < end && isAsciiTopicWhitespace(value[start])) start += 1
  while (end > start && isAsciiTopicWhitespace(value[end - 1])) end -= 1
  return value.slice(start, end)
}

export type TopicNameValidation =
  | { ok: true; name: string; length: number }
  | {
      ok: false
      name: string
      length: number
      reason: 'empty' | 'too_long'
    }

/** Normalize and validate using Unicode code-point count (`Array.from`), which
 * matches Rust `.chars().count()` and PostgreSQL `char_length`. */
export function validateTopicName(value: string): TopicNameValidation {
  const name = normalizeTopicName(value)
  const length = Array.from(name).length
  if (length === 0) return { ok: false, name, length, reason: 'empty' }
  if (length > MAX_TOPIC_NAME_LENGTH) {
    return { ok: false, name, length, reason: 'too_long' }
  }
  return { ok: true, name, length }
}
